import { useQuery } from '@apollo/client';

import type { RoleFragment } from 'bundles/onboarding-common/queries/__generated__/RoleFragment';
import InferredRoleQuery from 'bundles/unified-home-common/queries/InferredRoleQuery.graphql';
import type {
  InferredRoleQuery as InferredRoleQueryType,
  InferredRoleQueryVariables,
} from 'bundles/unified-home-common/queries/__generated__/InferredRoleQuery';

type UseGetPathwaysInferredRoleReturn = {
  pathwaysInferredRole: Pick<RoleFragment, 'id' | 'name'> | undefined;
  pathwaysInferredRoleLoading: boolean;
};

const useGetPathwaysInferredRole = ({ skip }: { skip: boolean }): UseGetPathwaysInferredRoleReturn => {
  const { data, loading: inferredRoleLoading } = useQuery<InferredRoleQueryType, InferredRoleQueryVariables>(
    InferredRoleQuery,
    {
      variables: {
        queryCollectionId: 'roles',
        limit: 1,
      },
      context: {
        clientName: 'gatewayGql',
      },
      ssr: true,
      skip,
    }
  );

  const pathwaysInferredRole = data?.Collection?.queryCollection.entities?.elements?.[0] as
    | Pick<RoleFragment, 'id' | 'name'>
    | undefined;

  return {
    pathwaysInferredRole,
    pathwaysInferredRoleLoading: inferredRoleLoading,
  };
};

export default useGetPathwaysInferredRole;
